export default "__VITE_ASSET__C56tGNAo__"